import { render, staticRenderFns } from "./ContactUsContent.vue?vue&type=template&id=b53329b4&"
import script from "./ContactUsContent.vue?vue&type=script&lang=js&"
export * from "./ContactUsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports